export default {
  timecards: {
    actual: 91584, // Actual
    currentPayPeriod: 95384, // Current Pay Period
    hideDetails: 101538, // Hide Details
    in: 100132, // In
    lastPayPeriod: 101532, // Last pay period
    looksLikeThereAreNoTimecardDetailsToShowForNow: 101540, // Hmm, looks like there are no timecard details to show for now - try and check back later!
    nothingToShowYet: 101539, // Nothing to show yet!
    out: 100133, // Out
    paid: 45818, // Paid
    paidHours: 101530, // Paid Hours
    paidTime: 91519, // Paid Time
    payPeriod: 81532, // Pay Period
    quickTip: 101536, // Quick Tip: Hover over each of the bars to see your breakdown!
    schedule: 81617, // Schedule
    seeDetails: 101537, // See Details
    timecard: 84016, // Timecard
    timecardDetails: 101534, // Timecard Details
    totalPaidHours: 101531, // Total paid hours
    viewTheBreakdownOfHowYouGotPaidForAGivenDay: 101535, // View the breakdown of how you got paid, for any given day!
    viewTimecardDetails: 101529, // View timecard details
    weekly: 63180, // Weekly
  }
}
